export default __webpack_public_path__ + "static/media/loading-icon.8401f966.svg";